import { render, staticRenderFns } from "./Tower3.vue?vue&type=template&id=1054262d&"
import script from "./Tower3.vue?vue&type=script&lang=js&"
export * from "./Tower3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports